import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const createHubTranslationRef = createTranslationRef({
  id: 'create-hub',
  messages: {
    createHub: {
      pageHeaderActionLabel: 'Import YAML',
      registerEntityActionLabel: 'Register Entity',
      headerTitle: "Don't know where to start?",
      headerDescription:
        'Read the quick start guides to familiarize yourself with the core concepts of creating and adding content in XELERATE',
      headerActionLabel: 'Start Guide',
      ownershipTitle: 'Ownership',
      ownershipDescription:
        'Create a home for your assets. You cannot register software without an owner.',
      groupTitle: 'Group',
      groupDescription:
        'Team, ART or department that owns and maintains assets',
      agenticResourcesTitle: 'Agentic Resources',
      agenticResourcesDescription:
        'Create and manage resources used to build and support agentic applications.',
      softwareAssetsTitle: 'Software Assets',
      softwareAssetsDescription:
        'Create your team’s assets and logical architecure. A System typically represents your product as a starting point.',
      systemTitle: 'System',
      systemDescription:
        'Groups related components and APIs into a single product or application',
      componentTitle: 'Component',
      componentDescription:
        'Modular, deployable unit of software, like a service, tool or library',
      apiTitle: 'API',
      apiDescription:
        'Interface specifications for your product (e.g. OpenAPI, MCP Server, gRPC)',
      aiResourceTitle: 'AI Resource',
      aiResourceDescription:
        'Resource for agentic applications (e.g. Agent, Skill, Rule)',
      resourceTitle: 'Resource',
      resourceDescription:
        'Specific instance of data or functionality accessible via an API',
    },
    templates: {
      noTemplateFound: 'No templates found. Learn more about',
      addingTemplate: 'adding templates',
      templateGroups: {
        defaultTitle: 'Templates',
        otherTitle: 'Other Templates',
      },
      additionalLinksForEntity: {
        viewTechDocsTitle: 'View TechDocs',
      },
      docModal: {
        headerTitle: 'View Documents',
      },
      actionMenu: {
        more: 'More',
        showTemplateDetails: 'Show template entity details',
        editConfiguration: 'Edit configuration',
      },
    },
  },
});
